import React, { useContext, useRef, useState } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../Cart'
import ImagePreview from './image-preview/ImagePreview'

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  const [modalImageShow, setModalImageShow] = useState(false)

  const selectedImageRef = useRef('')

  const previewTitleRef = useRef('')

  const showImagePreview = (title, image) => {
    previewTitleRef.current = title

    selectedImageRef.current = image

    setModalImageShow(true)
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Mã đơn</th>
              <th scope="col">Người chơi</th>
              <th scope="col">Số lượng vé</th>
              <th scope="col">Ngày tạo</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => <TableRow handleShowImagePreview={showImagePreview} rIndex={index} key={`table-keys-lottmekong-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <ImagePreview
        show={modalImageShow}
        title={previewTitleRef.current}
        image={selectedImageRef.current}
        onHide={() => setModalImageShow(false)}
      />
    </>
  );
};

export default React.memo(_Table)